<div *ngIf="showLoader" class="loader">
  <mat-spinner strokeWidth="3" diameter="100" color="#000"></mat-spinner>
</div>
<div class="background">
  <!-- <div class="card">
    <div class="card-body">
      <input type="text" placeholder="Search slips by ID, work order number, fault number or submitters name"
        class="search-text mw-60 p-1" />
      <img class="inputSearchx" alt="" />
      <img class="searchImage" alt="" />
    </div>
  </div> -->

  <h4 class="header mb-3">Create New Notification</h4>

  <div class="centerfield">
    <form class="example-form" [formGroup]="createNotification">
      <div class="nr-border-line">
        <div class="nr-subsection mb-2">Summary<sup>*</sup></div>
        <input type="text" formControlName="summaryNotification" class="form-control summarywidth mb-3"
          placeholder='Enter Summary'>
      </div>

      <div class="nr-border-line">
        <div class="nr-subsection mb-2">Description</div>
        <div class="quill-editor">
          <quill-editor [styles]="editorStyle" placeholder="Enter Text" formControlName="description"
            class="descripionwidth" [modules]="modules">
          </quill-editor>
        </div>
      </div>
      <!-- <div class="nr-border-line imageContiner">
        <div class="nr-subsection mb-3">Upload Image</div>
        <button #file mat-flat-button class="file-upload-button">Browse
          <input multiple (change)="onFileSelected($event)"
            style="opacity: 0; position:absolute; left:0px; top:0px; width:100%; height:100%;" type="file" />
        </button>
        <div class="textalignimage">

          <div *ngFor="let url of urls;let i = index">
            <div class="closeiamge">
              <img [src]="url" class="relevantPhotos" (click)="selectImage(i)">

              <img src="assets/images/close.png" (click)="deleteImage(i)" alt="up arrow" class="deleteimage"
                width="15px" />

            </div>
          </div>
        </div>

      </div> -->
      <div class="nrborderline">
        <div class="subsection">To be issued on</div>
        <div class="statusdesign">
            <div class="row m-1">
              <div class="col-md-4">
                <div class="row">
                  <div class="nr-subsection">Date<sup>*</sup></div>
                </div>
                <div class="input-group mb-3">
                  <input matInput  [matDatepicker]="picker" type="text" readonly class="form-control" placeholder="Select Date" formControlName="issueDate"
                    aria-label="Select Date" aria-describedby="basic-addon2" (click)="picker.open()">
                  <div class="input-group-append" (click)="picker.open()">
                    <span class="input-group-text" id="basic-addon2"><img src="./assets/images/icon-calendar.svg"
                        class="calendar-img"></span>
                  </div>
                  <mat-datepicker #picker type="datetime"></mat-datepicker>
                </div>
              </div>

              <div class="col-md-4">
                <div class="row">
                  <div class="nr-subsection">Time<sup>*</sup></div>
                </div>
                <div class="input-group mb-3">
                  <input matInput [ngxTimepicker]="fullTime" [format]="24" [min]="getMinTime()" readonly
                  formControlName="issuedTime" type="text" class="form-control" placeholder="Select Time"
                    aria-label="Select Time" aria-describedby="basic-addon2">
                  <div class="input-group-append" (click)="fullTime.open()">
                    <span class="input-group-text" id="basic-addon2"><img src="./assets/images/icon-time.svg"
                        class="calendar-img"></span>
                  </div>
                  <ngx-material-timepicker #fullTime></ngx-material-timepicker>
                </div>
              </div>
            </div>



            <!-- <div class="leftbox">
            <mat-form-field class="example-full-width">
              <input matInput [matDatepicker]="picker" [min]="minDate" class="datewidth" (click)="picker.open()"
                placeholder="Select Date" (dateChange)="currentPeriodClicked($event)" formControlName="issueDate">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker type="datetime"></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="middlebox">
            <div class="nr-subsection">Time<sup>*</sup></div>
            <div class="timepicker">
              <mat-form-field class="timefield">
                <input matInput [ngxTimepicker]="fullTime" [format]="24" [min]="getMinTime()"
                  formControlName="issuedTime" placeholder="Select Time">
                <ngx-material-timepicker-toggle matSuffix [for]="fullTime"></ngx-material-timepicker-toggle>
                <ngx-material-timepicker #fullTime></ngx-material-timepicker>
              </mat-form-field>
            </div>
          </div> -->
        </div>
      </div>
      <div class="nrborderline">
        <div class="buttonbox">
          <button type="button" class="btn btn-default btn-reset" (click)="reset()">
            Cancel
          </button>

          <button type="button" (click)="saveNotification(0)" [disabled]="!createNotification.valid"
            class="btn btn-default btn-submit" *ngIf="!isEdit">
            Create
          </button>

          <button type="button" (click)="saveNotification(1)" [disabled]="!createNotification.valid"
            class="btn btn-default btn-submit" *ngIf="isEdit">
            Update
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
